export default __webpack_public_path__ + "static/media/defense.04d24167.jpg";